import React, { useEffect, useRef, useState } from "react";
import InputTextfield from "components/common/atoms/InputTextField";
import Button from "components/common/atoms/Button";
import SendIcon from "static/images/SendIcon";
import type { ChatInputProps } from "../annotations/WhatsAppAnnotations";
import AttachmentMenu from "./AttachmentMenu";
import AddIcon from "static/images/AddIcon";
// import EmojiPicker, { EmojiClickData } from 'emoji-picker-react';
import EmojiPickerIcon from "static/images/EmojiPickerIcon";
// import data from '@emoji-mart/data'
// import Picker from '@emoji-mart/react'
import "emoji-picker-element";

const ChatInput: React.FC<ChatInputProps> = ({
  value,
  onChange,
  onSend,
  handleFileUpload,
  isMessageSending,
}) => {
  // for uploading media file
  const [showAttachments, setShowAttachments] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);

  const menuRef = useRef<HTMLDivElement>(null);
  const emojiRef = useRef<HTMLDivElement>(null);
  const emojiPickerRef = useRef<any>(null);

  const toggleMenu = () => setShowAttachments((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setShowAttachments(false);
      }
      if (emojiRef.current && !emojiRef.current.contains(e.target as Node)) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //*uploading file is done *//

  //
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey && !isMessageSending) {
      e.preventDefault(); // Optional: prevents line break in multi-line inputs
      onSend();
    }
  };

  //for emoji picker
  // useEffect(() => {
  //   if (!showEmojiPicker) return;

  //   const timeout = setTimeout(() => {
  //     const picker = emojiPickerRef.current;
  //     if (!picker) return;

  //     const handleEmojiClick = (event: any) => {
  //       const emoji = event.detail.unicode;
  //       const updatedValue = value.message + emoji;

  //       const syntheticEvent = {
  //         target: { value: updatedValue },
  //       } as React.ChangeEvent<HTMLInputElement>;

  //       onChange(syntheticEvent, "text");
  //     };

  //     picker.addEventListener("emoji-click", handleEmojiClick);

  //     // cleanup
  //     return () => {
  //       picker.removeEventListener("emoji-click", handleEmojiClick);
  //     };
  //   }, 0); // allow DOM to mount first

  //   return () => clearTimeout(timeout);
  // }, [showEmojiPicker, value.message, onChange]);
  useEffect(() => {
    if (!showEmojiPicker) {return;}

    const timeout = setTimeout(() => {
      const picker = emojiPickerRef.current;
      if (!picker) {return;}

      const handleEmojiClick = (event: any) => {
        const emoji = event.detail.unicode;
        const updatedValue = value.message + emoji;

        const syntheticEvent = {
          target: { value: updatedValue },
        } as React.ChangeEvent<HTMLInputElement>;

        onChange(syntheticEvent, "text");
      };

      picker.addEventListener("emoji-click", handleEmojiClick);

      // 🔽 Inject custom style inside Shadow DOM
      const injectStyles = () => {
        const shadow = picker.shadowRoot;
        if (!shadow) {return;}

        const styleEl = document.createElement("style");
        styleEl.textContent = `
       .search-row,
       .favorites {
       display:none !important;
       }
       .indicator {
       background-color:#e55496;
       }
       .emoji:hover, button.emoji:hover {
       background-color:#f1d8e8 !important;
       }
   /* 🎯 Scrollbar customization inside emoji list */
  ::-webkit-scrollbar {
    width: 0.45vw !important;
    height: 0.45vw !important;
  }

  ::-webkit-scrollbar-track {
    background: rgb(226, 226, 226) !important;
    border-radius: 0.5vw !important;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--color-dark-pink) !important;
    border-radius: 0.5vw !important;
  }
      `;

        // Prevent duplicate injection
        const existingStyle = shadow.querySelector("style[data-custom-input]");
        if (!existingStyle) {
          styleEl.setAttribute("data-custom-input", "true");
          shadow.appendChild(styleEl);
        }
      };

      // Emoji picker renders input after a tick, wait for it
      setTimeout(injectStyles, 150);

      // Cleanup
      return () => {
        picker.removeEventListener("emoji-click", handleEmojiClick);
      };
    }, 0);

    return () => clearTimeout(timeout);
  }, [showEmojiPicker, value.message, onChange]);

  return (
    <div className="chat-footer d-flex align-items-center">
      {/* Attachment Icon */}
      <div className="me-2" ref={menuRef}>
        <span
          className="d-flex align-items-center justify-content-center attachment-toggle-btn"
          onClick={toggleMenu}
        >
          <div
            className={`attachment-icon-wrapper table-action-icons cursor-pointer ${
              showAttachments ? "rotate-icon" : ""
            }`}
          >
            <AddIcon />
          </div>
        </span>

        <AttachmentMenu
          show={showAttachments}
          handleFileUpload={handleFileUpload}
        />
      </div>

      {/* Emoji Picker */}
      <span className="d-flex w-100 position-relative">
        {showEmojiPicker && (
          <div
            ref={emojiRef}
            className="emoji-picker-wrapper position-absolute marginBottomPoint5"
          >
            <emoji-picker ref={emojiPickerRef} />
          </div>
        )}

        {/* Text Input */}

        <span className="marginRight1 hideHeight position-relative inputWidth">
          <InputTextfield
            value={value.message}
            handleChange={(e: any) => onChange(e, "text")}
            placeholder="Type a message..."
            onKeyDown={handleKeyDown}
          />
        </span>
        <span className="position-absolute input-icon-position">
          <Button
            handleClick={() => setShowEmojiPicker((prev) => !prev)}
            className="border-0 bg-transparent table-action-icon"
          >
            <EmojiPickerIcon />
          </Button>
        </span>
      </span>

      <Button
        handleClick={() => onSend()}
        disabled={isMessageSending}
        className="table-action-icons cursor-pointer border-0 bg-transparent"
      >
        <SendIcon />
      </Button>
    </div>
  );
};

export default ChatInput;
